import { Link, usePage } from '@inertiajs/react'
import { type ReactNode } from 'react'
import DebtLensHeader from '@/components/debtlens/DebtLensHeader'

interface BorrowerUser {
  id: number
  email: string
}

interface Props {
  children: ReactNode
}

export default function BorrowerLayout({ children }: Props) {
  const props = usePage().props
  const currentBorrower = (props as Record<string, unknown>).current_borrower_user as BorrowerUser | null
  const flash = (props as Record<string, unknown>).flash as { notice: string | null; alert: string | null }

  const variant = currentBorrower ? 'authenticated' : 'public'

  return (
    <div className="min-h-screen bg-dl-workspace">
      <DebtLensHeader variant={variant} />

      {/* Flash messages */}
      {flash.notice && (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-3">
            <p className="text-sm text-emerald-800">{flash.notice}</p>
          </div>
        </div>
      )}
      {flash.alert && (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
          <div className="rounded-lg bg-red-50 border border-red-200 p-3">
            <p className="text-sm text-red-800">{flash.alert}</p>
          </div>
        </div>
      )}

      {/* Light workspace */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {children}
      </main>

      <footer className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 pb-8 mt-4 border-t border-gray-200 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-400">
        <span>DebtLens by LendSolo</span>
        <Link href="/privacy" className="hover:text-gray-600">Privacy Policy</Link>
      </footer>
    </div>
  )
}
